// extracted by mini-css-extract-plugin
export var page = "styles-module--page--32OAE";